import LeadList from './LeadList';

export default LeadList;
